import { atom } from "jotai";
import { workspaceAtom } from "./workspace.atoms";
import { AuthRepository } from "@/infrastructure/repositories/auth";
import { GetWorkspaceSettingsUseCase, GetWorkSpaceUseCase, GetWorkspaceUserRoles } from "@/core/usecases/workspace";
import { WorkSpaceRepository } from "@/infrastructure/repositories/workspace";

// Action atoms
export const setWorkspaceAtom = atom(null, async (get, set) => {
  try {
    const workspace = await new GetWorkSpaceUseCase(new WorkSpaceRepository(new AuthRepository())).execute();

    const workspaceUserRoles = await new GetWorkspaceUserRoles(new WorkSpaceRepository(new AuthRepository())).execute();

    const workspaceSettings = await new GetWorkspaceSettingsUseCase(new WorkSpaceRepository(new AuthRepository())).execute();

    const hasWorkspace = workspace !== null;
    set(workspaceAtom, {
      ...get(workspaceAtom),
      workspace,
      settings: workspaceSettings,
      isLoading: false,
      hasWorkspace,
      userRoleNames: workspaceUserRoles.roleNames,
      error: null,
    });
  } catch (error: unknown) {
    set(workspaceAtom, {
      ...get(workspaceAtom),
      isLoading: false,
      error: error instanceof Error ? error : new Error("An unknown error occurred"),
    });
  }
});
